<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="btn-show-modal-dining-items-removed"
      data-bs-toggle="modal"
      data-bs-target="#modalDiningItemsRemoved"
    ></button>
    <div
      class="modal fade"
      id="modalDiningItemsRemoved"
      tabindex="-1"
      aria-labelledby="modalDiningItemsRemovedLabel"
      aria-hidden="true"
    >
      <KskModalShell :width="680" :show-close="false">
        <div class="ksk-removed">
          <div class="ksk-removed__icon">
            <span class="material-icons-round">remove_shopping_cart</span>
          </div>
          <h2 id="modalDiningItemsRemovedLabel" class="ksk-removed__title">{{ $t("kiosk.dining.removedTitle") }}</h2>
          <p class="ksk-removed__reason">{{ reason }}</p>
          <ul class="ksk-removed__list">
            <li v-for="(item, index) in items" :key="index" class="ksk-removed__item">
              <span class="ksk-removed__qty">{{ item.quantity }}×</span>
              <span class="ksk-removed__name">{{ item.name }}</span>
            </li>
          </ul>
        </div>
        <template #footer>
          <KskButton
            size="md"
            class="btn-hide-modal-dining-items-removed ksk-removed__btn"
            data-bs-dismiss="modal"
          >{{ $t("kiosk.common.ok") }}</KskButton>
        </template>
      </KskModalShell>
    </div>
  </div>
</template>

<script>
import KskModalShell from "@/views/kiosk/components/ui/KskModalShell.vue";
import KskButton from "@/views/kiosk/components/ui/KskButton.vue";

// KSK055 — after a dining switch, lists the cart items dropped because they
// carry an option restricted to the other dining option.
export default {
  name: "ModalDiningItemsRemoved",
  components: {
    KskModalShell,
    KskButton,
  },
  props: {
    // [{ name, quantity }]
    items: {
      type: Array,
      default: () => [],
    },
    // The dining option switched to: 1 = take away | 2 = dine in
    diningOption: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    reason() {
      const dineIn = this.$t("kiosk.common.dineIn");
      const takeAway = this.$t("kiosk.common.takeAway");
      return this.$t("kiosk.dining.removedReason", {
        from: this.diningOption == 1 ? dineIn : takeAway,
        to: this.diningOption == 1 ? takeAway : dineIn,
      });
    },
  },
};
</script>

<style scoped>
.ksk-removed {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.ksk-removed__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #fdf0dc;
  color: #b25e00;
}
.ksk-removed__icon .material-icons-round {
  font-size: 42px;
}
.ksk-removed__title {
  margin: var(--ksk-space-2) 0 0;
  font-family: var(--ksk-font);
  font-size: var(--ksk-title-size);
  line-height: var(--ksk-title-lh);
  font-weight: 700;
  color: var(--ksk-text);
}
.ksk-removed__reason {
  margin: var(--ksk-space-1) 0 0;
  font-size: 20px;
  line-height: 28px;
  color: var(--ksk-text-secondary);
}
.ksk-removed__list {
  width: 100%;
  max-height: 320px;
  overflow-y: auto;
  margin: var(--ksk-space-3) 0 0;
  padding: 0;
  list-style: none;
  text-align: left;
}
.ksk-removed__item {
  display: flex;
  gap: var(--ksk-space-2);
  padding: var(--ksk-space-2) var(--ksk-space-3);
  border-radius: 16px;
  background: var(--ksk-surface-muted);
  font-size: 22px;
  line-height: 30px;
  color: var(--ksk-text);
}
.ksk-removed__item + .ksk-removed__item {
  margin-top: var(--ksk-space-1);
}
.ksk-removed__qty {
  flex: none;
  font-weight: 700;
}
.ksk-removed__name {
  min-width: 0;
  overflow-wrap: anywhere;
}
.ksk-removed__btn {
  flex: 1 1 0;
  min-width: 0;
}
</style>
